var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      pad: "0",
      title: _vm.$t("label_essweb_attendanceInternal_form_viewTitle"),
      widthClass: "max-1000",
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: { curTab: _vm.curTab, items: _vm.taber },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "white lighten-5",
                              attrs: { align: "center", justify: "start" },
                            },
                            [
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix: _vm.$getDateTime(
                                        _vm.AttendanceData.utc_att_date,
                                        "YYYY/MM/DD"
                                      ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_dateLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "single-line": "",
                                      readonly: "",
                                      suffix: _vm.AttendanceData.staff_code,
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_staffIdLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix: _vm.$getCommonLangValue(
                                        _vm.AttendanceData.schedule_shift_name
                                      ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_scheduleShiftNameLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix: _vm.$getDateTime(
                                        _vm.AttendanceData
                                          .schedule_start_utc_time,
                                        "HH:mm"
                                      ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_scheduleStartTimeLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix:
                                        _vm.getDays(
                                          _vm.AttendanceData
                                            .schedule_end_utc_time,
                                          _vm.AttendanceData
                                            .schedule_start_utc_time
                                        ) +
                                        _vm.$getDateTime(
                                          _vm.AttendanceData
                                            .schedule_end_utc_time,
                                          "HH:mm"
                                        ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_scheduleEndTimeLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix: _vm.$getCommonLangValue(
                                        _vm.AttendanceData.official_shift_name
                                      ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_officailShiftNameLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix: _vm.$getDateTime(
                                        _vm.AttendanceData
                                          .official_start_utc_time,
                                        "HH:mm"
                                      ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_officialStartTimeLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix:
                                        _vm.getDays(
                                          _vm.AttendanceData
                                            .official_end_utc_time,
                                          _vm.AttendanceData
                                            .official_start_utc_time
                                        ) +
                                        _vm.$getDateTime(
                                          _vm.AttendanceData
                                            .official_end_utc_time,
                                          "HH:mm"
                                        ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_officialEndTimeLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix:
                                        _vm.AttendanceData.Status == "1"
                                          ? _vm.$t(
                                              "label_essweb_system_status_onLabel"
                                            )
                                          : _vm.$t(
                                              "label_essweb_system_status_offLabel"
                                            ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_statusLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix: Number(
                                        _vm.AttendanceData.is_onduty
                                      )
                                        ? _vm.$t(
                                            "label_essweb_system_label_trueLabel"
                                          )
                                        : _vm.$t(
                                            "label_essweb_system_label_falseLabel"
                                          ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_isOnDutyLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      suffix: Number(
                                        _vm.AttendanceData.is_locked
                                      )
                                        ? _vm.$t(
                                            "label_essweb_system_label_trueLabel"
                                          )
                                        : _vm.$t(
                                            "label_essweb_system_label_falseLabel"
                                          ),
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_isLockedLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--primary pl-1" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_attendanceInternal_form_tagLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      prefix:
                                        (Number(_vm.AttendanceData.is_late)
                                          ? _vm.$t(
                                              "label_essweb_system_tag_label_lateLabel"
                                            )
                                          : "") +
                                        (Number(
                                          _vm.AttendanceData.is_early_leave
                                        )
                                          ? "," +
                                            _vm.$t(
                                              "label_essweb_system_tag_label_earlyLeaveLabel"
                                            )
                                          : "") +
                                        (Number(_vm.AttendanceData.is_ot)
                                          ? "," +
                                            _vm.$t(
                                              "label_essweb_system_tag_label_otLabel"
                                            )
                                          : "") +
                                        (Number(_vm.AttendanceData.is_absense)
                                          ? "," +
                                            _vm.$t(
                                              "label_essweb_system_tag_label_absenseLabel"
                                            )
                                          : "") +
                                        (Number(_vm.AttendanceData.is_on_leave)
                                          ? "," +
                                            _vm.$t(
                                              "label_essweb_system_tag_label_leaveLabel"
                                            )
                                          : "") +
                                        (Number(
                                          _vm.AttendanceData.is_early_leave
                                        )
                                          ? "," +
                                            _vm.$t(
                                              "label_essweb_system_tag_label_earlyLeaveLabel"
                                            )
                                          : "") +
                                        (Number(_vm.AttendanceData.is_holiday)
                                          ? "," +
                                            _vm.$t(
                                              "label_essweb_system_tag_label_holidayLabel"
                                            )
                                          : ""),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_isPunchInRequiredLabel"
                                      ),
                                      readonly: "",
                                      suffix: Number(
                                        _vm.AttendanceData.is_punch_in_required
                                      )
                                        ? _vm.$t(
                                            "label_essweb_system_label_trueLabel"
                                          )
                                        : _vm.$t(
                                            "label_essweb_system_label_falseLabel"
                                          ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_isPunchOutRequiredLabel"
                                      ),
                                      readonly: "",
                                      suffix: Number(
                                        _vm.AttendanceData.is_punch_out_required
                                      )
                                        ? _vm.$t(
                                            "label_essweb_system_label_trueLabel"
                                          )
                                        : _vm.$t(
                                            "label_essweb_system_label_falseLabel"
                                          ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_actualPunchInIdLabel"
                                      ),
                                      readonly: "",
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_actualPunchInTimetimeZoneLabel"
                                      ),
                                      readonly: "",
                                      suffix: _vm.$getUtcTime(
                                        _vm.AttendanceData
                                          .actual_punch_in_utc_datetime,
                                        _vm.AttendanceData
                                          .actual_punch_in_time_zone
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_actualPunchOutIdLabel"
                                      ),
                                      readonly: "",
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_actualPunchOutTimetimeZoneLabel"
                                      ),
                                      readonly: "",
                                      suffix: _vm.$getUtcTime(
                                        _vm.AttendanceData
                                          .actual_punch_out_utc_datetime,
                                        _vm.AttendanceData
                                          .actual_punch_out_time_zone
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_modifiPunchInIdLabel"
                                      ),
                                      readonly: "",
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_modifiPunchInTimetimeZoneLabel"
                                      ),
                                      readonly: "",
                                      suffix: _vm.$getUtcTime(
                                        _vm.AttendanceData
                                          .modified_punch_in_utc_datetime,
                                        _vm.AttendanceData
                                          .modified_punch_in_time_zone
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_modifiPunchOutIdLabel"
                                      ),
                                      readonly: "",
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_modifiPunchOutTimetimeZoneLabel"
                                      ),
                                      readonly: "",
                                      suffix: _vm.$getUtcTime(
                                        _vm.AttendanceData
                                          .modified_punch_out_utc_datetime,
                                        _vm.AttendanceData
                                          .modified_punch_out_time_zone
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_officialPunchInIdLabel"
                                      ),
                                      readonly: "",
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_officialPunchInTimetimeZoneLabel"
                                      ),
                                      readonly: "",
                                      suffix: _vm.$getUtcTime(
                                        _vm.AttendanceData
                                          .official_punch_in_utc_datetime,
                                        _vm.AttendanceData
                                          .official_punch_in_time_zone
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_officialPunchOutIdLabel"
                                      ),
                                      readonly: "",
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_officialPunchOutTimetimeZoneLabel"
                                      ),
                                      readonly: "",
                                      suffix: _vm.$getUtcTime(
                                        _vm.AttendanceData
                                          .official_punch_out_utc_datetime,
                                        _vm.AttendanceData
                                          .official_punch_out_time_zone
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_isPunchCriteriaMatchedLabel"
                                      ),
                                      readonly: "",
                                      suffix: Number(
                                        _vm.AttendanceData
                                          .is_punch_criteria_matched
                                      )
                                        ? _vm.$t(
                                            "label_essweb_system_label_trueLabel"
                                          )
                                        : _vm.$t(
                                            "label_essweb_system_label_falseLabel"
                                          ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_actualWorkingMinutesLabel"
                                      ),
                                      readonly: "",
                                      suffix:
                                        _vm.AttendanceData.actual_working_minutes.toString(),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_officialworkingMinutesLabel"
                                      ),
                                      readonly: "",
                                      suffix:
                                        _vm.AttendanceData.official_working_minutes.toString(),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_shiftPropertyGroupLabel"
                                      ),
                                      readonly: "",
                                      suffix: _vm.$getCommonLangValue(
                                        _vm.AttendanceData
                                          .shift_property_group_name
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_relatedApplicationsLabel"
                                      ),
                                      readonly: "",
                                      suffix:
                                        _vm.AttendanceData.application_uuid,
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      prefix: _vm.$t(
                                        "label_essweb_attendanceInternal_form_remarkLabel"
                                      ),
                                      readonly: "",
                                      suffix: _vm.AttendanceData.remarks,
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-card",
                        {
                          staticClass: "elevation-1 pa-0 ma-auto",
                          attrs: { elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-text",
                            {
                              staticClass:
                                "px-3 white fill-height from_content",
                            },
                            [
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.desserts,
                                  "single-expand": true,
                                  "hide-default-header": "",
                                  expanded: _vm.expanded,
                                  "show-expand": "",
                                  "expand-icon": "mdi-unfold-less-horizontal",
                                  "hide-default-footer": "",
                                  page: _vm.page,
                                  "fixed-header": true,
                                  elevation: 0,
                                  "item-key": "uuid",
                                  "items-per-page":
                                    _vm.$tableSetting.perPageSize,
                                },
                                on: {
                                  "update:expanded": function ($event) {
                                    _vm.expanded = $event
                                  },
                                  "update:page": function ($event) {
                                    _vm.page = $event
                                  },
                                  "page-count": function ($event) {
                                    _vm.$tableSetting.pageCount = $event
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "no-data",
                                    fn: function () {
                                      return [_c("noContent")]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "item.name",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "mt-4 mb-4" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.event_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "expanded-item",
                                    fn: function (ref) {
                                      var headers = ref.headers
                                      var item = ref.item
                                      return [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "white",
                                            staticStyle: { border: "none" },
                                            attrs: { colspan: headers.length },
                                          },
                                          [
                                            _c(
                                              "v-form",
                                              [
                                                _c(
                                                  "v-row",
                                                  [
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "12" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              item.staff_code,
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_staffIdLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "12" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getCommonLangValue(
                                                                item.schedule_shift_name
                                                              ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_scheduleShiftNameLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getDateTime(
                                                                item.schedule_start_utc_time,
                                                                "HH:mm"
                                                              ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_scheduleStartTimeLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              _vm.getDays(
                                                                item.schedule_end_utc_time,
                                                                item.schedule_start_utc_time
                                                              ) +
                                                              _vm.$getDateTime(
                                                                item.schedule_end_utc_time,
                                                                "HH:mm"
                                                              ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_scheduleEndTimeLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "12" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getCommonLangValue(
                                                                item.official_shift_name
                                                              ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_officailShiftNameLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getDateTime(
                                                                item.official_start_utc_time,
                                                                "HH:mm"
                                                              ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_officialStartTimeLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              _vm.getDays(
                                                                item.official_end_utc_time,
                                                                item.official_start_utc_time
                                                              ) +
                                                              _vm.$getDateTime(
                                                                item.official_end_utc_time,
                                                                "HH:mm"
                                                              ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_officialEndTimeLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              item.total_minutes.toString(),
                                                            prefix: _vm.$t(
                                                              "label_essweb_shift_list_totalMinutesLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-col", {
                                                      attrs: { md: "6" },
                                                    }),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getCommonLangValue(
                                                                item.event_type_name
                                                              ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_eventType_list_eventTypeNameLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix:
                                                              item.event_type_uuid,
                                                            prefix:
                                                              _vm.$t(
                                                                "label_essweb_eventType_list_eventTypeNameLabel"
                                                              ) + "ID",
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix: Number(
                                                              item.is_onduty
                                                            )
                                                              ? _vm.$t(
                                                                  "label_essweb_system_label_trueLabel"
                                                                )
                                                              : _vm.$t(
                                                                  "label_essweb_system_label_falseLabel"
                                                                ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_isOnDutyLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix: Number(
                                                              item.is_locked
                                                            )
                                                              ? _vm.$t(
                                                                  "label_essweb_system_label_trueLabel"
                                                                )
                                                              : _vm.$t(
                                                                  "label_essweb_system_label_falseLabel"
                                                                ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_isLockedLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix: Number(
                                                              item.is_punch_in_required
                                                            )
                                                              ? _vm.$t(
                                                                  "label_essweb_system_label_trueLabel"
                                                                )
                                                              : _vm.$t(
                                                                  "label_essweb_system_label_falseLabel"
                                                                ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_isPunchInRequiredLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly: "",
                                                            suffix: Number(
                                                              item.is_punch_out_required
                                                            )
                                                              ? _vm.$t(
                                                                  "label_essweb_system_label_trueLabel"
                                                                )
                                                              : _vm.$t(
                                                                  "label_essweb_system_label_falseLabel"
                                                                ),
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_isPunchOutRequiredLabel"
                                                            ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_actualPunchInIdLabel"
                                                            ),
                                                            readonly: "",
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_actualPunchInTimetimeZoneLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getUtcTime(
                                                                item.actual_punch_in_utc_datetime,
                                                                item.actual_punch_in_time_zone
                                                              ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_actualPunchOutIdLabel"
                                                            ),
                                                            readonly: "",
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_actualPunchOutTimetimeZoneLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getUtcTime(
                                                                item.actual_punch_out_utc_datetime,
                                                                item.actual_punch_out_time_zone
                                                              ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_modifiPunchInIdLabel"
                                                            ),
                                                            readonly: "",
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_modifiPunchInTimetimeZoneLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getUtcTime(
                                                                item.modified_punch_in_utc_datetime,
                                                                item.modified_punch_in_time_zone
                                                              ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_modifiPunchOutIdLabel"
                                                            ),
                                                            readonly: "",
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_modifiPunchOutTimetimeZoneLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getUtcTime(
                                                                item.modified_punch_out_utc_datetime,
                                                                item.modified_punch_out_time_zone
                                                              ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_officialPunchInIdLabel"
                                                            ),
                                                            readonly: "",
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_officialPunchInTimetimeZoneLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getUtcTime(
                                                                item.official_punch_in_utc_datetime,
                                                                item.official_punch_in_time_zone
                                                              ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_officialPunchOutIdLabel"
                                                            ),
                                                            readonly: "",
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_officialPunchOutTimetimeZoneLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getUtcTime(
                                                                item.official_punch_out_utc_datetime,
                                                                item.official_punch_out_time_zone
                                                              ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_isPunchCriteriaMatchedLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix: Number(
                                                              item.is_punch_criteria_matched
                                                            )
                                                              ? _vm.$t(
                                                                  "label_essweb_system_label_trueLabel"
                                                                )
                                                              : _vm.$t(
                                                                  "label_essweb_system_label_falseLabel"
                                                                ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-col", {
                                                      attrs: { md: "6" },
                                                    }),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_actualWorkingMinutesLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              item.actual_working_minutes.toString(),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_list_officialWorkingMinutesLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              item.official_working_minutes.toString(),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_lateMinutesLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              item.late_minutes.toString(),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_earlyLeaveMinutesLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              item.early_leave_minutes.toString(),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_originalLeaderLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              item.original_leader_staff_uuid,
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_partTimeLeaderLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              item.parttime_learder_staff_uuid,
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "12" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_shiftPropertyGroupLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              _vm.$getCommonLangValue(
                                                                item.event_property_group_name
                                                              ),
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { md: "12" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            prefix: _vm.$t(
                                                              "label_essweb_attendanceInternal_form_remarkLabel"
                                                            ),
                                                            readonly: "",
                                                            suffix:
                                                              item.remarks,
                                                            dense: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }